import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.js'
import { Provider } from "react-redux";
import * as serviceWorker from './serviceWorker'
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/msalConfig.js';
import { store } from "./_redux/_store";

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <Provider store={store}>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    </Provider>,
    document.getElementById('root')
);
  
serviceWorker.unregister()
